import type { CountryCode } from "libphonenumber-js/max";
import { parsePhoneNumber } from "libphonenumber-js/max";

import { normalizeNumber } from "@/helpers/phone_number/phone_number.helpers";

/**
 * Format an e164 phone number to the international format.
 * (ported from the legacy dashboard library helper)
 * @param number - Phone number in e164 format (ex: 33176420302)
 * @param countryCode - Optional ISO country code used to parse national numbers
 * @returns Phone number in international format (ex: +33 1 76 42 03 02)
 */
export const formatInternationalNumber = (
  number: string,
  countryCode?: CountryCode
): string => {
  try {
    if (countryCode) {
      return parsePhoneNumber(number, countryCode).formatInternational();
    }
    return parsePhoneNumber(normalizeNumber(number)).formatInternational();
  } catch {
    // invalid phone number; fallback to the original format
    return number;
  }
};

/**
 * Formats a score to display exactly 1 decimal place.
 * @param value - The numeric score
 * @returns A string with exactly 1 decimal (e.g. "18.1", "85.0")
 */
export const formatScoreDisplay = (value: number): string => value.toFixed(1);

/**
 * Rounds a score to 1 decimal place, returning a number.
 * Use when passing to components that expect numeric values.
 * @param value - The numeric score
 * @returns A number rounded to 1 decimal (e.g. 18.1, 85)
 */
export const formatScoreValue = (value: number): number =>
  parseFloat(value.toFixed(1));
